import type { ComponentProps } from "react";

import ContactDetailsOverlayState from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactDetails/ContactDetailsOverlayState";

type Props = Omit<ComponentProps<typeof ContactDetailsOverlayState>, "onReveal"> & {
    onClick: VoidFunction;
};

const ContactDetailsOverlayToButtonAdapter = ({ onClick, ...props }: Props) => {
    return (
        <ContactDetailsOverlayState
            {...props}
            onReveal={onClick}
        />
    );
};

export default ContactDetailsOverlayToButtonAdapter;
